import { Injectable } from '@angular/core';
import {AngularFireDatabase, AngularFireList} from '@angular/fire/database';
import {AngularFireStorage, AngularFireStorageModule} from '@angular/fire/storage';
import {FileUpload} from '../model/file-upload';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { PandsFileUpload } from '../model/pands-file-upload';
import { GalFileUpload } from '../model/gal-file-upload';
import { noUndefined } from '@angular/compiler/src/util';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {
obj : any;
username : any;
profileurl : string;
pandsurl : string;
galurl : string;
  private  basePath = '/profilepic';
  private  userPath = '/profilepic';
  private  pandsbasePath = '/productservice';
  private  galbasePath = '/gallery';

  individual_name_path : any;
  constructor(private db: AngularFireDatabase,private firestore: AngularFirestore, private storage: AngularFireStorage) {
    this.obj = JSON.parse(localStorage.getItem('user')|| '{}');
    if(localStorage.getItem('user') === '{}'){
      this.username = 0;
    }else{
    this.username = this.obj.email;
  }
    if(this.username  > 0){
    this.userPath = this.username.replace(/[^a-zA-Z ]/g, "");
    }
    // this.firestore.collection("users").ref.where("username", "==", this.obj.email).onSnapshot(snap =>{
    //   snap.forEach(userRef => {
    //     this.username = userRef.data()["name"];
    //   })});
  }
  push_pands_FileToStorage(pandsFileUpload : PandsFileUpload, rowid: string): Observable<number>{
    const filePath = `${this.pandsbasePath}/${this.userPath}/${rowid}/${pandsFileUpload.file.name}`;
    const storageRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, pandsFileUpload.file);
    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        storageRef.getDownloadURL().subscribe(downloadURL => {
          console.log('File available at', downloadURL);
          pandsFileUpload.url = downloadURL;
          this.pandsurl = downloadURL;
          pandsFileUpload.name = pandsFileUpload.file.name;
          pandsFileUpload.email = this.obj.email;
          this.pandsSaveFileData(pandsFileUpload, rowid);
        });
      })
    ).subscribe();
    return uploadTask.percentageChanges();
  }
  private pandsSaveFileData(pandsFileUpload: PandsFileUpload, a: string) {
    // this.db.list(this.basePath).push(fileUpload);
    let update_details={
      pandsurl: this.pandsurl,
    }
    this.firestore.collection("productsandservices").doc(this.obj.email).collection(a).doc(a).update(update_details)
    .then(user => {
      window.alert("File Uploaded Successfully....");
     }).catch(err => {
      console.log(err);
    })
  }

  push_gallery_FileToStorage(galFileUpload : GalFileUpload, rowid: string): Observable<number>{
    const filePath = `${this.galbasePath}/${this.userPath}/${rowid}/${galFileUpload.file.name}`;
    const storageRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, galFileUpload.file);
    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        storageRef.getDownloadURL().subscribe(downloadURL => {
          console.log('File available at', downloadURL);
          galFileUpload.url = downloadURL;
          this.galurl = downloadURL;
          galFileUpload.name = galFileUpload.file.name;
          galFileUpload.email = this.obj.email;
          this.galSaveFileData(galFileUpload, rowid);
        });
      })
    ).subscribe();
    return uploadTask.percentageChanges();
  }
  private galSaveFileData(galFileUpload: GalFileUpload, a: string) {
    // this.db.list(this.basePath).push(fileUpload);
    let update_details={
      galurl: this.galurl,
    }
    this.firestore.collection("gallery").doc(this.obj.email).collection(a).doc(a).update(update_details)
    .then(user => {
      window.alert("File Uploaded Successfully....");
     }).catch(err => {
      console.log(err);
    })
  }

  pushFileToStorage(fileUpload: FileUpload): Observable<number> {
    const filePath = `${this.basePath}/${this.userPath}/${fileUpload.file.name}`;
    const storageRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, fileUpload.file);
    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        storageRef.getDownloadURL().subscribe(downloadURL => {
          console.log('File available at', downloadURL);
          fileUpload.url = downloadURL;
          this.profileurl = downloadURL;
          fileUpload.name = fileUpload.file.name;
          fileUpload.email = this.obj.email;
          this.saveFileData(fileUpload);
        });
      })
    ).subscribe();
    return uploadTask.percentageChanges();
  }
  private saveFileData(fileUpload: FileUpload) {
    // this.db.list(this.basePath).push(fileUpload);
    let update_details={
      profileurl: this.profileurl,
    }
    this.firestore.collection("basicdetails").doc(this.obj.email).update(update_details)
    .then(user => {
     }).catch(err => {
      console.log(err);
    })



  }

  pushEmployeeProfilePicFileToStorage(fileUpload: FileUpload): Observable<number> {
    const filePath = `${this.basePath}/${this.userPath}/${fileUpload.file.name}`;
    const storageRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, fileUpload.file);
    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        storageRef.getDownloadURL().subscribe(downloadURL => {
          console.log('File available at', downloadURL);
          fileUpload.url = downloadURL;
          this.profileurl = downloadURL;
          fileUpload.name = fileUpload.file.name;
          fileUpload.email = this.obj.email;
          this.saveEmpProfFileData(fileUpload);
        });
      })
    ).subscribe();
    return uploadTask.percentageChanges();
  }
  private saveEmpProfFileData(fileUpload: FileUpload) {
    // this.db.list(this.basePath).push(fileUpload);
    let update_details={
      profileurl: this.profileurl,
    }
    this.firestore.collection("users").doc(this.obj.email).update(update_details)
    .then(user => {

     }).catch(err => {
      console.log(err);
    })



  }


  pushAgentProfilePicFileToStorage(fileUpload: FileUpload): Observable<number> {
    const filePath = `${this.basePath}/${this.userPath}/${fileUpload.file.name}`;
    const storageRef = this.storage.ref(filePath);
    const uploadTask = this.storage.upload(filePath, fileUpload.file);
    uploadTask.snapshotChanges().pipe(
      finalize(() => {
        storageRef.getDownloadURL().subscribe(downloadURL => {
          console.log('File available at', downloadURL);
          fileUpload.url = downloadURL;
          this.profileurl = downloadURL;
          fileUpload.name = fileUpload.file.name;
          fileUpload.email = this.obj.email;
          this.saveAgentProfFileData(fileUpload);
        });
      })
    ).subscribe();
    return uploadTask.percentageChanges();
  }
  private saveAgentProfFileData(fileUpload: FileUpload) {
    // this.db.list(this.basePath).push(fileUpload);
    let update_details={
      profileurl: this.profileurl,
    }
    this.firestore.collection("users").doc(this.obj.email).update(update_details)
    .then(user => {

     }).catch(err => {
      console.log(err);
    })



  }



  getFileUpload(numberItems): AngularFireList<FileUpload> {
    return  this.db.list(this.basePath, ref =>
    ref.limitToLast(numberItems));
  }
  deleteFileUpload(fileUpload: FileUpload) {
    this.deleteFileDatabase(fileUpload.key).then(() => {
      this.deleteFileStorage(fileUpload.name);
    }).catch(error => console.log(error));
  }
  private deleteFileDatabase(key: string) {
    return this.db.list(this.basePath).remove(key);
  }
  private deleteFileStorage(name: string) {
    const storageRef = this.storage.ref(this.basePath);
    storageRef.child(name).delete();
  }

}
